(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swt-counterpart"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('swt-counterpart');
  if (!root) return;

  var IS_OB = root.dataset.isOb === 'true';
  var CURRENCY = root.dataset.currency || 'CAD';

  var CURRENT = JSON.parse(document.getElementById('swt-counterpart-current').textContent);
  var CP = JSON.parse(document.getElementById('swt-counterpart-data').textContent);

  var els = {
    chip:  document.getElementById('swt-counterpart-chip'),
    link:  document.getElementById('swt-counterpart-link'),
    img:   document.getElementById('swt-counterpart-img'),
    price: document.getElementById('swt-counterpart-price'),
    title: document.getElementById('swt-counterpart-title'),
    atc:   document.getElementById('swt-counterpart-atc')
  };

  function money(cents) {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: CURRENCY })
      .format(Number(cents || 0) / 100);
  }

  function targetSku(sku) {
    if (!sku) return null;
    return IS_OB ? sku.replace(/-OB$/i, '') : sku + '-OB';
  }

  function currentVariantId() {
    var input = document.querySelector('[data-swt-pdp] [data-variant-id]');
    if (input && CURRENT[input.value]) return input.value;
    var p = new URLSearchParams(window.location.search).get('variant');
    if (p && CURRENT[p]) return p;
    return Object.keys(CURRENT)[0];
  }

  function pickCounterpart(curId) {
    var cur = CURRENT[curId];
    if (!cur) return null;
    var want = targetSku(cur.sku);
    var exact = null, fallback = null;
    for (var i = 0; i < CP.variants.length; i++) {
      var v = CP.variants[i];
      if (!v.available) continue;
      if (want && v.sku && v.sku.toUpperCase() === want.toUpperCase()) { exact = v; break; }
      if (!fallback) fallback = v;
    }
    return exact || fallback;
  }

  function render() {
    var curId = currentVariantId();
    var cur = CURRENT[curId];
    var cp = pickCounterpart(curId);

    if (!cp) { root.hidden = true; return; }

    var href = CP.url + '?variant=' + cp.id;
    els.link.href = href;
    els.title.href = href;
    if (cp.img) els.img.src = cp.img;
    els.price.textContent = money(cp.price);
    els.atc.dataset.variantId = cp.id;

    if (IS_OB) {
      els.chip.textContent = 'Upgrade to Brand New — Full Warranty';
    } else {
      var save = cur.price - cp.price;
      els.chip.textContent = save > 0
        ? 'Save ' + money(save) + ' with Open Box'
        : 'Open Box available';
    }
    root.hidden = false;
  }

  els.atc.addEventListener('click', function () {
    var id = parseInt(els.atc.dataset.variantId, 10);
    if (!id) return;
    els.atc.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('atc failed'); return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('swt:cart:added'));
        if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
          window.Rebuy.SmartCart.show();
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () { els.atc.disabled = false; });
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-option-input]') || t.matches('[data-variant-select]')) {
      setTimeout(render, 50);
    }
  });

  render();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swt-hero-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('swt-fp-carousel')) {
    customElements.define('swt-fp-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.slides = Array.from(this.track.children);
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = 0;
        if (this.slides.length < 2) return;

        const prev = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', () => { this.userStop(); this.go(this.index - 1); });
        if (next) next.addEventListener('click', () => { this.userStop(); this.go(this.index + 1); });
        this.dots.forEach((d, i) => d.addEventListener('click', () => { this.userStop(); this.go(i); }));

        this.track.addEventListener('scroll', () => {
          clearTimeout(this._syncT);
          this._syncT = setTimeout(() => this.sync(), 80);
        }, { passive: true });

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !reduce;
        this.interval = parseInt(this.dataset.interval, 10) || 5000;
        if (this.autoplay) {
          this.start();
          ['mouseenter', 'focusin', 'touchstart', 'pointerdown'].forEach(e => this.addEventListener(e, () => this.stop(), { passive: true }));
          ['mouseleave', 'focusout'].forEach(e => this.addEventListener(e, () => this.start()));
          this._vis = () => (document.hidden ? this.stop() : this.start());
          document.addEventListener('visibilitychange', this._vis);
        }

        if (window.Shopify && Shopify.designMode) {
          this._onBlockSelect = (e) => {
            const i = this.slides.findIndex(s => s === e.target || s.contains(e.target));
            if (i > -1) { this.userStop(); this.go(i); }
          };
          document.addEventListener('shopify:block:select', this._onBlockSelect);
        }
      }
      disconnectedCallback() {
        this.stop();
        if (this._vis) document.removeEventListener('visibilitychange', this._vis);
        if (this._onBlockSelect) document.removeEventListener('shopify:block:select', this._onBlockSelect);
      }
      go(i) {
        const n = this.slides.length;
        i = (i + n) % n;
        this.index = i;
        this.track.scrollTo({ left: this.slides[i].offsetLeft, behavior: 'smooth' });
        this.paint();
      }
      sync() {
        const w = this.track.clientWidth;
        if (!w) return;
        const i = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / w)));
        if (i !== this.index) { this.index = i; this.paint(); }
      }
      paint() {
        this.dots.forEach((d, i) => {
          if (i === this.index) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      }
      start() {
        if (!this.autoplay || this._userStopped) return;
        this.stop();
        this._timer = setInterval(() => this.go(this.index + 1), this.interval);
      }
      stop() { clearInterval(this._timer); this._timer = null; }
      userStop() { this._userStopped = true; this.stop(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swt-main-product"] && !Shopify.designMode) return;
  try {
    
  (()=>{document.querySelectorAll("[data-swt-pdp]").forEach(root=>{
    const money=c=>new Intl.NumberFormat(undefined,{style:"currency",currency:root.dataset.currency||"CAD"}).format(Number(c||0)/100);
    root.querySelectorAll("[data-specs] li").forEach(li=>{
      const t=li.firstChild;
      if(!t||t.nodeType!==3)return;
      const raw=t.textContent;
      const i=raw.indexOf(":");
      if(i<1||i>28)return;
      const label=document.createElement("strong");
      label.className="swt-spec-label";
      label.textContent=raw.slice(0,i).trim();
      t.textContent=raw.slice(i+1).trim();
      li.insertBefore(label,t);
    });
    root.querySelectorAll("details.swt-pdp__acc").forEach(d=>d.addEventListener("toggle",()=>{if(d.open)window.dispatchEvent(new Event("resize"))}));
    const openTarget=sel=>{if(!sel)return;let t=null;try{t=root.querySelector(sel)}catch(e){t=null}if(t&&t.tagName==="DETAILS")t.open=true};
    root.querySelectorAll(".swt-pdp__nav a").forEach(a=>a.addEventListener("click",()=>openTarget(a.getAttribute("href"))));
    if(location.hash)openTarget(location.hash);
    root.querySelectorAll("[data-thumb]").forEach(btn=>btn.addEventListener("click",()=>{
      root.querySelectorAll("[data-media]").forEach(el=>el.hidden=el.dataset.media!==btn.dataset.thumb);
      root.querySelectorAll("[data-thumb]").forEach(el=>el.classList.toggle("is-active",el===btn));
    }));
    const qty=root.querySelector("[data-qty-input]");
    const minus=root.querySelector("[data-qty-minus]");
    const plus=root.querySelector("[data-qty-plus]");
    if(qty&&minus)minus.addEventListener("click",()=>{qty.value=Math.max(Number(qty.min||1),Number(qty.value||1)-1)});
    if(qty&&plus)plus.addEventListener("click",()=>{qty.value=Number(qty.value||1)+1});
    const jsonEl=root.querySelector("[data-variants-json]");
    let variants=[];try{variants=jsonEl?JSON.parse(jsonEl.textContent):[]}catch(e){variants=[]}
    const price=root.querySelector("[data-price]");
    const compare=root.querySelector("[data-compare]");
    const sale=root.querySelector("[data-sale]");
    const sold=root.querySelector("[data-sold]");
    const add=root.querySelector("[data-add]");
    const payment=root.querySelector("[data-payment]");
    const availability=root.querySelector("[data-availability]");
    const upc=root.querySelector("[data-upc]");
    const idInput=root.querySelector("[data-variant-id]");
    const setState=(available,label)=>{
      if(sold){sold.classList.toggle("is-hidden",available);if(!available)sold.textContent=label}
      if(add){add.disabled=!available;add.textContent=available?root.dataset.addText:label}
      if(payment)payment.classList.toggle("is-hidden",!available);
      if(availability){availability.textContent=available?"In stock":label;availability.classList.toggle("is-available",available);availability.classList.toggle("is-unavailable",!available)}
    };
    const showVariantMedia=v=>{
      if(!v||!v.featured_media||!v.featured_media.id)return;
      const mid=String(v.featured_media.id);
      if(!root.querySelector('[data-media="'+mid+'"]'))return;
      root.querySelectorAll("[data-media]").forEach(el=>el.hidden=el.dataset.media!==mid);
      root.querySelectorAll("[data-thumb]").forEach(el=>el.classList.toggle("is-active",el.dataset.thumb===mid));
    };
    const update=v=>{
      if(!v){setState(false,root.dataset.unavailableText||"Unavailable");return}
      if(idInput)idInput.value=v.id;
      if(price)price.textContent=money(v.price);
      if(compare){const show=Number(v.compare_at_price)>Number(v.price);compare.textContent=show?money(v.compare_at_price):"";compare.classList.toggle("is-hidden",!show);if(sale)sale.classList.toggle("is-hidden",!show)}else if(sale){sale.classList.toggle("is-hidden",!(Number(v.compare_at_price)>Number(v.price)))}
      if(upc){const parent=upc.closest("[hidden]")||upc.closest(".swt-pdp__fact");const code=v.barcode||"";upc.textContent=code;if(parent&&parent.classList.contains("swt-pdp__fact"))parent.hidden=!code}
      showVariantMedia(v);
      setState(!!v.available,root.dataset.soldText);
    };
    const select=root.querySelector("[data-variant-select]");
    if(select)select.addEventListener("change",()=>{const v=variants.find(x=>String(x.id)===select.value);update(v)});
    const pills=root.querySelectorAll("[data-option-input]");
    if(pills.length){
      const groups=[...root.querySelectorAll(".swt-pdp__optionset")];
      const resolve=()=>{
        const chosen=groups.map(g=>{const c=g.querySelector("[data-option-input]:checked");return c?c.value:null});
        if(chosen.some(v=>v===null))return null;
        return variants.find(v=>chosen.every((val,i)=>v.options[i]===val));
      };
      pills.forEach(p=>p.addEventListener("change",()=>update(resolve())));
    }
    const form=root.querySelector(".swt-pdp__form");
    if(form){
      form.addEventListener("submit",e=>{
        e.preventDefault();
        const btn=root.querySelector("[data-add]");
        if(btn)btn.disabled=true;
        fetch("/cart/add.js",{method:"POST",headers:{"Accept":"application/json"},body:new FormData(form)})
          .then(r=>{if(!r.ok)throw new Error("atc failed");return r.json()})
          .then(()=>{
            document.dispatchEvent(new CustomEvent("swt:cart:added"));
            if(window.Rebuy&&window.Rebuy.SmartCart&&typeof window.Rebuy.SmartCart.show==="function"){
              window.Rebuy.SmartCart.show();
            }else{
              window.location.href="/cart";
            }
          })
          .catch(()=>{form.submit()})
          .finally(()=>{if(btn){btn.disabled=false;btn.textContent=root.dataset.addText}});
      });
    }
  })})();

  } catch(e) { console.error(e); }
})();
})();
